import React, { Component } from 'react';
import UrlConstants from '../../constants/UrlConstants';
import { Dispatch } from 'redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container } from '@mui/material';
import { List as ImmutableList } from 'immutable';
import { RootState } from '../../setup';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { createStyles, withStyles } from '@mui/styles';
import IMenuItem from '../../interfaces/common/menuItem';
import MainLayout from '../common/widgets/mainLayout';
import PageUtils from '../../utils/pageUtils';
import { Theme } from '@mui/material';
import { ObjectType } from '../../constants/constants';
import Paging from '../../interfaces/common/paging';
import LanguageUtils from '../../utils/LanguageUtils';
import { GridSortModel, GridSortDirection, GridSortItem, GridColumnVisibilityModel } from '@mui/x-data-grid';
import { deleteSeller, fetchSellerById, getSeller, isDeletingSeller, isLoadingSeller, resetSeller } from '../../reducers/sellerReducer';
import Seller from '../../interfaces/output/seller';
import ViewSeller from './viewSeller';
import { ensure } from '../../utils/arrayUtils';

interface ISellerDetailsProps {
    classes: any;
    theme: Theme;
    fetchSellerById: any;
    seller: Seller;
    match: any;
    history: any;
    location: any;
    isLoadingSeller: boolean;
    resertSeller: () => void;
    isDeletingSeller: boolean;
    deleteSeller: any;
}

interface ISellerDetailsState {
    seller: Seller;
    menuItems: ImmutableList<IMenuItem>;
    selectedRow?: number;
    serverProductPagination: Paging;
    sortModel: GridSortModel;
    columnVisibilityModel: GridColumnVisibilityModel;
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchSellerById: (sellerId: any) => dispatch(fetchSellerById(sellerId)),
    resertSeller: () => dispatch(resetSeller()),
    deleteSeller: (sellerId: any) => dispatch(deleteSeller(sellerId))
});

const messages = {
    edit: LanguageUtils.createMessage('Edit'),
    properties: LanguageUtils.createMessage('Properties'),
    seller: LanguageUtils.createMessage('Seller'),
    delete: LanguageUtils.createMessage('Delete')
};

const mapStoreToProps = (store: RootState) => {
    return {
        seller: getSeller(store),
        isLoading: isLoadingSeller(store) || isDeletingSeller(store),
        isDeletingSeller: isDeletingSeller(store)
    };
};

const styles = (theme: Theme) => createStyles({
    container: {
        padding: theme.spacing(4)
    },
    link: {
        textDecoration: 'none',
        color: `${theme.palette.info.main}!important`,
        fontSize: '12px!important'
    }
});

class SellerDetails extends Component<ISellerDetailsProps, ISellerDetailsState> {
    constructor(props: ISellerDetailsProps) {
        super(props);

        this.state = {
            seller: {} as Seller,
            menuItems: ImmutableList([{
                id: 1,
                name: messages.properties,
                icon: <FontAwesomeIcon icon="info-circle" size="1x" transform="grow-4" />,
                additionalMargin: true,
                url: `/${UrlConstants.SELLERS}/${props.match.params.sellerId}/properties`,
                isSelected: PageUtils.isPageSelected(`/${UrlConstants.SELLERS}/${props.match.params.sellerId}/properties`, props.location.pathname)
            }
            ]),
            serverProductPagination: PageUtils.getDefaultPaging(),
            selectedRow: undefined,
            sortModel: [{
                field: '',
                sort: '' as GridSortDirection
            } as GridSortItem],
            columnVisibilityModel: {

            }
        };
    }

    componentDidMount() {
        const { fetchSellerById } = this.props;
        const { sellerId } = this.props.match.params;

        fetchSellerById(sellerId);
    }

    componentDidUpdate(prevProps: ISellerDetailsProps) {
        const { seller, isDeletingSeller, history } = this.props;

        if(seller !== prevProps.seller) {
            this.setState({ seller });
        }

        if(prevProps.location.pathname && this.props.location.pathname !== prevProps.location.pathname) {
            const menuItems = this.state.menuItems.map((menuItem: IMenuItem) => {
                menuItem.isSelected = PageUtils.isPageSelected(menuItem.url, this.props.location.pathname);

                return menuItem;
            });

            this.setState({
                menuItems: menuItems,
                selectedRow: undefined
            });
        }

        if(!isDeletingSeller && prevProps.isDeletingSeller) {
            history.push(`/${UrlConstants.SELLERS}`);
        }
    }

    componentWillUnmount() {
        resetSeller();
    }

    getSelectedMenuItem = (state: ISellerDetailsState) => state.menuItems.find(item => item.isSelected);

    deleteSeller = () => {
        const { deleteSeller } = this.props;
        const { sellerId } = this.props.match.params;

        deleteSeller(ensure(sellerId));
    }

    handleMenuItems = () => {
        const { menuItems } = this.state;
        const selectedMenuItem = menuItems.find((item: IMenuItem) => item.isSelected);
        const selectedMenuItemId = selectedMenuItem?.id;
        const { sellerId } = this.props.match.params;

        switch (selectedMenuItemId) {
            case 1: { //details
                return [
                    {
                        href: `${UrlConstants.SELLERS}/${sellerId}/edit`,
                        icon: 'edit',
                        text: messages.edit
                    },
                    {
                        icon: 'ban',
                        text: messages.delete,
                        onClick: this.deleteSeller
                    }
                ];
            }

            default: {
                return [];
            }
        }
    }

    render() {
        const { classes, isLoadingSeller } = this.props;
        const { seller, menuItems } = this.state;

        return (
            <MainLayout actions={this.handleMenuItems()}
                isLoading={isLoadingSeller}
                menuItems={menuItems}
                includeDrawer
                objectType={ObjectType.User}
                menuItem={{
                    id: 1,
                    subname: messages.seller,
                    value: seller?.id,
                    icon: <FontAwesomeIcon icon="user-friends" size="1x" />
                } as IMenuItem}
            >
                <Container className={classes.container} maxWidth="xl">
                    <Switch>
                        <Route path={`/${UrlConstants.SELLERS}/:sellerId/properties`}>
                            <ViewSeller seller={seller} />
                        </Route>
                    </Switch>
                </Container>
            </MainLayout>
        );
    }
}

export default withStyles(styles)(connect(mapStoreToProps, mapDispatchToProps)(SellerDetails));